<template>
  <nav>
    <ul class="tgb-ul-reset tabs">
      <slot>
        <li
          v-for="(tab, index) in tabs"
          :key="index"
        >
          <button
            class="tabs__tab"
            :class="activeTab === index ? 'tabs__tab--active' : ''"
            type="button"
            role="tab"
            :aria-controls="tab.contentId"
            :data-entity="`producer-dashboard-${tab.key}`"
            @click="onClickTab(tab, index)"
          >
            {{ tab.title }}
          </button>
        </li>
      </slot>

      <slot name="tabAfterLast" />
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'TgbTabs',

  props: {
    activeTab: {
      type: Number,
      required: true,
      default: 0,
    },
  },

  data() {
    return {
      tabs: [
        {
          key: 'allProduction',
          title: 'All Productions',
          contentId: 'all',
        },
        {
          key: 'deletedProductions',
          title: 'Deleted Productions',
          contentId: 'deleted',
        },
      ],
    };
  },

  methods: {
    onClickTab(tab, index) {
      if (index !== this.activeTab) {
        this.$emit('tab-clicked', { tab, index });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  position: relative;
  padding: 0;
  list-style: none;
  grid-gap: 32px;
  display: flex;
  margin-bottom: 2rem;
}

.tabs__trailing-tab {
  flex-grow: 1;
  text-align: right;

  + .tabs__trailing-tab {
    flex-grow: 0;
  }

  .far {
    margin-right: 8px;
  }
}

.tabs__tab {
  background-color: transparent;
  border-width: 0;
  padding: 0;
  font-family: 'Barlow', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 150%;
  color: #808689;

  &--active {
    font-weight: 700;
    color: inherit;

    &::after {
      display: block;
      height: 3px;
      width: 100%;
      background: #23CDF4;
      position: relative;
      content: "";
      bottom: -3px;
    }
  }
}
</style>
